module.exports = __webpack_public_path__ + "img/ic_contentitem_magazin.0ee8c039.svg";